module.exports = __webpack_public_path__ + "static/media/chat.03c4afae.svg";